import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";


function* fetchRecipiesInstructions() {
  try {
    const result = yield call(AxiosCall, `/sporetools/get_recipes_instructions/`);
    yield put(actions.fetchRecipeInstructionsSuccess(result.data))
  } catch (e) {
    yield put(actions.fetchRecipeInstructionsFailure(e))
  }
}


function* fetchRecipiesProportions(action) {
  try {
    const result = yield call(AxiosPost, `/sporetools/get_recipes_proportions/`, action.payload);
    yield put(actions.fetchRecipeProportionsSuccess(result.data))
  } catch (e) {
    yield put(actions.fetchRecipeProportionsFailure(e))
  }
}










export default function* rootSaga() {
  yield all([
    // Watchers Articles
    takeLatest(actions.FETCH_RECIPES_INSTRUCTIONS.REQUEST, fetchRecipiesInstructions),
    takeLatest(actions.FETCH_RECIPES_PROPORTIONS.REQUEST, fetchRecipiesProportions),


  ])
}

